import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=3fdd1029&"
import script from "./MainPage.vue?vue&type=script&lang=js&"
export * from "./MainPage.vue?vue&type=script&lang=js&"
import style0 from "./MainPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\LAVK\\Desktop\\MedSafe\\System\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fdd1029')) {
      api.createRecord('3fdd1029', component.options)
    } else {
      api.reload('3fdd1029', component.options)
    }
    module.hot.accept("./MainPage.vue?vue&type=template&id=3fdd1029&", function () {
      api.rerender('3fdd1029', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/MainPage.vue"
export default component.exports